module.exports = new __parcel__URL__("ZcashLogo.5ee68c2f.svg").toString();